module.exports = new __parcel__URL__("level_prog_bar.1e6091b5.png").toString();